import { initProductVariantQuantity } from "../components/quantity";
import { appendToUrl } from "../search/urlUtils";
import { toggleAddressFormVisibility } from "../login/loginUtil";
import ProductQtyMap from "./ProductQtyMap";
import { INPUT_BG_COLOR_DEFAULT, MASK_ACTIVE_CLASS, PAGE_HEIGHT_SET_TIMING } from "./constants";
import { mask } from "./mask";

const debounce = require("lodash/debounce");
const $document = $(document);
const $body = $("body");
const $window = $(window);
const $page = $(".page");
const regex = require("./regex");
const mqueryRespond = window.mqRespond;
let consentModalWasOpen = false;
let personalAdvConsentModelWasOpen = false;
let windowWidth;
let windowHeight;

/**
 *  Checks if the current device is running iOS
 *
 * @returns {Boolean}
 */
const isIOS = () => {
    if (!navigator.platform.length) { return false; }
    const iDevices = [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
        "MacIntel"
    ];

    return iDevices.includes(navigator.platform) && !window.MSStream;
};

/**
 * Get iOS version
 */
const iosVersion = () => {
    if (!isIOS()) return;

    const version = (navigator.appVersion).match(regex.values.iosVersion);

    if (version == null) return;

    return parseInt(version[1], 10);
};

/**
 *  Checks if the current device is running Firefox
 *
 * @returns {Boolean}
 */
const isFirefox = () => {
    return !!window.sidebar;
};

/**
 * Close opened modals
 */
const closeOpenedModals = () => {
    const $openedModal = $(".modal.show");
    consentModalWasOpen = false;
    personalAdvConsentModelWasOpen = false;

    if ($openedModal.is("#consent-tracking")) {
        consentModalWasOpen = true;
    }
    else if ($openedModal.is("#consent-personal-advertisement-modal")) {
        personalAdvConsentModelWasOpen = true;
    }

    $openedModal.modal("hide");
};

/**
 * @function
 * @description - Check if current browser is Safari
 */
const isSafari = () => { return !!navigator.userAgent.match(regex.values.isSafari); };

/**
*  Targets inside DOM the SVG from the given parameter to return its HTML
* @param {string} element - Class name for icon to be searched inside dom
* @param {string} container - Class name for icons container to be searched inside dom
* @returns {HTML}
*/
const getSVGIcon = (element, container = "") => {
    const svgElement = document.querySelector(`${container} .svg-${element}`);
    return svgElement && svgElement.outerHTML;
};

/**
 * Register the event from the overlay element and redirects it to the tab header
 * Making sure the user clicked and not scrolled on mobile
 *
 * @param {string} className
 */
const touchstartScrollFix = className => {
    let touchmoved;
    const overlayElements = document.getElementsByClassName(className);

    const triggerClick = (element) => {
        if (touchmoved != true) {
            element.nextElementSibling.click();
        }
    };

    Array.from(overlayElements).forEach(function (element) {
        element.addEventListener("touchend", () => triggerClick(element));
        element.addEventListener("touchmove", () => touchmoved = true);
        element.addEventListener("touchstart", () => touchmoved = false);
    });
};

/**
 * Checks for not allowed values
 *
 * @param {string} val
 */
const hasNotAllowedValues = val => {
    return ["", "null", "undefined", null, undefined].includes(val);
};

/**
 * Checks if the resize event is real and not a URL bar visibility toggle
 * Used mostly for iOS devices
 *
 * @param {number} oldWidth width of the window before the resize event was triggered
 */
const realResizeEvent = (oldWidth) => {
    if (oldWidth != $(window).width()) { return true; }
};

/**
 *  Checks if the current device is a mobile
 *
 * @returns {Boolean}
 */
const isMobile = () => { return !!navigator.userAgent.match(regex.values.isMobile); };

/**
 * Initialize the Quantity Component
 *
 * @param {string} pid
 * @param {string} selector
 */
const initializeQtyComponent = (pid, selector, selectedUnit = null) => {
    initProductVariantQuantity(pid, selector, selectedUnit);
};

/**
 * Finds a given product id in the basket map
 * @param {String} pid product id
 * @returns {Boolean} true or false if product was found;
 */
const isProductInBasket = (pid) => {
    const productPosition = ProductQtyMap.items.find((product) => {
        return product.id == pid || product.masterID == pid;
    });

    return !!productPosition;
};

/**
 * Removes from carousel all the tiles which are found in basket
 * @param {Object} carousel jquery object with the carousel
 */
const removeBasketProductTiles = (carousel) => {
    carousel.find(".product").each(function (idx, item) {
        const currentPid = $(item).data("pid");
        if (isProductInBasket(currentPid)) {
            $(item).parent(".pd-tile-wrap").remove();
        }
    });
};

/**
 * @function
 * @description - Animate the full height page when the orientation is changed
 */
const animatePageGrow = () => {
    const $pageMainContent = document.getElementById("maincontent");

    if (windowHeight !== window.innerHeight) { setPageMinHeight(); }

    $pageMainContent.classList.add("not-extended");
    setTimeout(() => { $pageMainContent.classList.remove("not-extended"); }, 200);
};

/**
 * @function
 * @description - Set minimum page height
 */
const setPageMinHeight = () => {
    setTimeout(() => {
        windowHeight = window.innerHeight;
        $page.css("min-height", window.innerHeight);
        document.dispatchEvent(new CustomEvent("page.minHeightSet"));
    }, PAGE_HEIGHT_SET_TIMING);
};

/**
 * @function
 * @description - Set private parameter for logout if the page is private
 */
const handlePrivateLogout = () => {
    const $logoutBtn = document.querySelectorAll(".js-logout");
    const isPrivateArea = document.getElementById("maincontent").getAttribute("data-private-area");
    if (isPrivateArea === "false" || !$logoutBtn) { return; }

    $logoutBtn.forEach(element => {
        element.addEventListener("click", (e) => {
            e.preventDefault();
            let url = e.currentTarget.getAttribute("href");
            const urlParams = {
                isprivate: true
            };
            url = appendToUrl(url, urlParams);
            window.location.replace(url);
        });
    });
};

/**
 * Check if element has scrollbar
 * @param {Element} element - Element to be checked
 */
const hasScrollbar = element => {
    return element.clientHeight < element.scrollHeight;
};

/**
* Updates the index of pagination for the slider (e.g: Current active: slide index X out of Y maximum slides)
* @param {object} element - Initialized slick slider element
*/
const updateCarouselPaginationBasedOnIndex = element => {
    const $this = element;
    if (!$this) { return; }

    const $slideIndexStatus = $(".js-current-slide-status");
    const indexResource = $slideIndexStatus.data("resource");
    const currentActiveSlide = $this.slick("slickCurrentSlide") + 1;
    const noOfTotalSlides = $this.find(".slick-slide").length;
    const updatedText = indexResource.replace("{0}", currentActiveSlide).replace("{1}", noOfTotalSlides);
    $slideIndexStatus.text(updatedText);
};

/**
* updates zip-code on focusout if it has only 4 digits
*/
const appendPostalOnFocus = (zipcodeInput = ".ct-address-form--zipcode-input") => {
    $(document).off("focusout").on("focusout", zipcodeInput, e => {
        const $this = $(e.target);
        let postalCode = $this.val();
        if (postalCode && postalCode.length == 4) {
            if (regex.values.digits.test(postalCode)) {
                postalCode = postalCode.padEnd(8, "-000");
                $this.val(postalCode);
            }
            toggleAddressFormVisibility($this);
        }
    });
};

/**
 * @function
 * @description - Check using navigator the browser name based on the browserName parameter
 * @param {string} browserName - Browser name
 * @returns {boolean} - if userAgent contains browserName parameter value
 */
const isBrowserName = browserName => {
    return navigator.userAgent.toLowerCase().indexOf(browserName) >= 0;
};

/**
* Add filled class on js-autofill-enabled class inputs when page loads
*/
const setFilledStatus = () => {
    const isChromeOrSafari = isBrowserName("chrome") || isBrowserName("safari") ? true : false;

    setTimeout(() => {
        const inputsAutofill = document.querySelectorAll("input.js-autofill-enabled");

        inputsAutofill.forEach(element => {
            if (isChromeOrSafari) {
                if (getComputedStyle(element).backgroundColor !== INPUT_BG_COLOR_DEFAULT) {
                    element.classList.add("filled");
                }
            } else {
                if (element.value !== "") {
                    element.classList.add("filled");
                }
            }
        });
    }, 400);
};

/**
* Takes the highest height of all given elements and applies it to the others
* @param {object} element - Elements to get and apply height
*/
const syncHeight = element => {
    const selector = element;
    let maxHeight = -1;

    selector.each((index, item) => {
        maxHeight = maxHeight > $(item).height() ? maxHeight : $(item).height();
    });

    if (maxHeight <= 0) { return; }

    selector.each((index, item) => {
        $(item).height(maxHeight);
    });
};

/**
* Applies highest height to the carousel tiles or resets the height to auto
* @param {object} element - Elements to get and apply height
*/
const syncHeightCarouselTiles = element => {
    if (!element) { return; }
    const $el = $(element);

    if (!mqueryRespond.status.mobile) {
        resetHeightOnTiles($el);
        return;
    }

    if ($el.hasClass("slick-initialized")) {
        syncHeight($el.find(".pd-tile-wrap"));
    } else {
        $el.off("init setPosition").on("init setPosition", () => {
            syncHeight($el.find(".pd-tile-wrap"));
        });
    }
};

/**
* Reset height on tiles to auto
* @param {object} element - Elements to get and apply height
*/
const resetHeightOnTiles = element => {
    if (!element) { return; }

    const $el = $(element);
    $el.find(".pd-tile-wrap").css("height", "auto");
};

/**
* Filters the values inserted into the input based on the given input
* @param {object} textbox - Input element to bind the event to
* @param {string} inputFilter - Regex to filter the input' value
*/
const setInputFilter = (textbox, inputFilter) => {
    ["input", "keydown", "keyup"].forEach(e => {
        textbox.addEventListener(e, function (event) {
            if (event.key === "Enter") { return; }
            if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            } else if (Object.hasOwnProperty.call(this, "oldValue")) {
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            } else {
                this.value = "";
            }
        });
    });
};

/**
* Handles postal code input rules based on user's input
* Adds masking for digits or removes the masking for letters
*/
const handlePostalCodeInputRules = () => {
    document.querySelectorAll("#coverage-postal-code").forEach(elem => {
        elem.addEventListener("keydown", (e) => {
            const postalCode = e.currentTarget;

            if (postalCode.value.match(regex.values.digitsAndDash)) {
                if (postalCode.classList.contains(MASK_ACTIVE_CLASS)) { return; }
                $(postalCode).addClass(MASK_ACTIVE_CLASS).mask(mask.postalCode);
            } else {
                if (!postalCode.classList.contains(MASK_ACTIVE_CLASS)) { return; }
                $(postalCode).removeClass(MASK_ACTIVE_CLASS).unmask();
            }
        });
    });
};

/**
* Limits the user's input based on the input element' regex
*/
const limitInputToRegex = () => {
    const strictInputs = document.querySelectorAll("input[data-strict-input]");

    strictInputs.forEach(input => {
        if (!input.pattern) { return; }

        const state = {
            value: input.value,
            start: input.selectionStart,
            end: input.selectionEnd,
            pattern: RegExp(input.pattern)
        };

        input.addEventListener("input", () => {
            if (state.pattern.test(input.value) || input.value == "") {
                state.value = input.value;
            } else {
                input.value = state.value;
                input.setSelectionRange(state.start, state.end);
            }
        });

        input.addEventListener("keydown", () => {
            state.start = input.selectionStart;
            state.end = input.selectionEnd;
        });
    });
};

/**
 * Removes < > to avoid running script
 *
 * @param {String} value - search phrase
 */
const xssEscaper = value => {
    return value.replace(/[<>]/g, "");
};

/**
* Init Global Utilities
*/
const globalUtilInit = () => {
    let resizeTimer;

    $document.ready(function () {
        handlePrivateLogout();
        setPageMinHeight();
        setFilledStatus();
        limitInputToRegex();

        windowWidth = $window.width();
    });

    $window.on("resize", debounce(function () {
        if (windowHeight !== window.innerHeight) { setPageMinHeight(); }

        if (!realResizeEvent(windowWidth)) { return; }
        windowWidth = $window.width();
        closeOpenedModals();

        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            if (consentModalWasOpen) { $("#consent-tracking").modal("show"); }
            else if (personalAdvConsentModelWasOpen) { $("#consent-personal-advertisement-modal").modal("show"); }
        }, 250);
    }, 250));

    $window.on("scroll", debounce(() => {
        if (windowHeight !== window.innerHeight) { setPageMinHeight(); }
    }, 200));

    $window.on("orientationchange", animatePageGrow);

    $document.on("lazyloaded", function (e) {
        $(e.target).parent("picture").addClass("img-loaded");
    });

    $body.on("product:afterAddToCart", (event, data) => {
        if (data && data.product || data && data.productImpression && data.productImpression.id) {
            const productId = data.product?.id || data.productImpression.id;
            const $carouselContainer = $(`.product[data-pid=${productId}]`).closest(".slick-initialized");

            setTimeout(() => {
                resetHeightOnTiles($carouselContainer);
                syncHeightCarouselTiles($carouselContainer);
            }, 100);
        }
    });

    $body.on("product:tileProductRemoval", (event, $tile) => {
        if (!$tile) { return; }
        const $carouselContainer = $tile.closest(".slick-initialized");
        resetHeightOnTiles($carouselContainer);
        syncHeightCarouselTiles($carouselContainer);
    });
};

/**
* Set the src with what we have in the `data-src` attribute
* @param {string} - containerElement - container class which contain the targeted images
*/
const loadLazyImages = containerElement =>  {
    const container = containerElement ? document.querySelector(containerElement) : document;
    if (!container) { return; }

    container.querySelectorAll("img.lazyload:not(.lazyloaded)").forEach(img => {
        if (!img.src) {
            img.src = img.dataset.src;
            img.classList.remove("hidden", "lazyload");
            img.classList.add("lazyloaded");
        }
    });
};

/**
* Returns the height of the viewport
*/
const getViewportHeight = () => Math.max(document.documentElement.offsetHeight, window.innerHeight || 0);

/**
* Loops through the targetted elements, get their heights and outputs a total height number
* @param {elems} - Elements - DOM elements for which we get the height that should be substracted
*/
const getTotalHeightToSubstract = elems => [...elems].reduce((total, elem) => total + $(elem).outerHeight(true), 0);

/**
* Sets the dynamic height for an elementLoops through the targetted elements, get their heights and outputs a total height number
* @param {targetElem} - Node element - Target node element that will get the dynamic height
* @param {elems} - Array - DOM elements for which we get the height that should be substracted
* @param {contingencyHeight} - Number - Value that can be used in case there is some additional value to be substracted, it defaults to 0
*/
const setDynamicHeight = (targetElem, elems, contingencyHeight = 0) => {
    if (targetElem == null) { return; }
    targetElem.style.height = `${getViewportHeight() - getTotalHeightToSubstract(elems) - contingencyHeight}px`;
};

/**
* Trigger the click event of an element when one of it's parent element is clicked
* @param {parentElem} - String - Parent element that find the target element and click the event that is attached to it
* @param {targetElement} - String - Target element to which is attached the click event
*/
const triggerClickFromParent = (parentElem, targetElement) => {
    const parent = document.querySelector(parentElem);
    const target = parent?.querySelector(targetElement);

    if (parent == null || target == null) { return; }

    parent.addEventListener("click", () => target.click());
};

/**
* Transforms string with dashes into camel case string without dashes
* @param {string} - String - String that will be transformed
* @returns {string} - String resulted
*/
const dashesToCamelCase = string => {
    if (!string) { return; }
    return string.toLowerCase().replace(/-(.)/g, (match, group1) => {
        return group1.toUpperCase();
    });
};

/**
* Based on quick view modal state, correctly queues modal visibility events
*/
const handleModalStateVisibilityQV = () => {
    const modalsState = sessionStorage.getItem("modalsState");
    const currentModalsState = modalsState ? JSON.parse(modalsState) : "";
    const qvIdSelector = "#quick-view-modal";

    if (currentModalsState?.quickViewModal == "hide") {
        $body.one("hidden.bs.modal", qvIdSelector, () => {
            $(qvIdSelector).modal("toggle");
        });
    } else if (currentModalsState?.quickViewModal == "show") {
        $body.one("shown.bs.modal", qvIdSelector, () => {
            $(qvIdSelector).modal("toggle");
        });
    } else {
        $(qvIdSelector).modal("toggle");
    }
};

/**
* Dynamically sets the height of the active menu
* @param {Boolean} - isTopPage - If users is on top of page
*/
const setMenuHeight = (isTopPage) => {
    const isMobileOrTablet = window.mqRespond.status.mobile || window.mqRespond.status.tablet;

    if (!isMobileOrTablet) {
        return;
    }

    const mainMenuMarginTop = parseInt($(".main-menu-wrapper").css("margin-top"), 10);
    const searchMobileHeight = parseInt($(".search-mobile").height(), 10);
    let headerHeight = parseInt($(".header").height(), 10) + mainMenuMarginTop;

    if (searchMobileHeight > 0) {
        headerHeight -= searchMobileHeight;
    }

    // percentage of height of the navbar if it is at the top of the page
    const heightTopPageNavbar = "100";
    // percentage of height of the navbar if the user is not at the top of the page
    const heightNotTopPageNavbar = "107";
    let percentage = (isTopPage == true) ? heightTopPageNavbar : heightNotTopPageNavbar;
    $(".main-menu-wrapper.active-menu").css("height", `calc(${percentage}% - ${headerHeight}px)`);
};

/**
 * Sanitizes the special character values inside the string
 * and replaces them with the caracter related to them in the provided mapping
 * @param {string} value - String that will be transformed
 * @returns {string} String resulted
**/
const sanitizeValue = value => {
    const pageElement = document.querySelector(".page");
    if (pageElement === null) { return value; }

    const specialChars = pageElement?.dataset?.specialChars;
    if (specialChars === undefined) { return value; }

    const specialCharsObj = JSON.parse(specialChars);

    return value.split("").map(char => {
        const charFound = Object.entries(specialCharsObj).find(arr => arr[1].includes(char));

        return charFound === undefined ? char : charFound[0];
    }).join("");
};

/**
 * Checks if the element is in viewport
 * @param {string} elem - The element that will be checked if it's in viewport
**/
const isInViewport = elem => {
    const bounding = elem.getBoundingClientRect();
    return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
};

/**
 * Waits for an element to appear in the DOM, then executes a callback.
 * @param {string} selector - The CSS selector of the target element.
 * @param {function} callback - The function to execute once the element is found.
**/
var waitForEl = function (selector, callback) {
    if (jQuery(selector).length) {
        callback();
    } else {
        setTimeout(function () {
            waitForEl(selector, callback);
        }, 100);
    }
};

export {
    globalUtilInit,
    isIOS,
    iosVersion,
    isSafari,
    getSVGIcon,
    touchstartScrollFix,
    hasNotAllowedValues,
    realResizeEvent,
    isMobile,
    initializeQtyComponent,
    isProductInBasket,
    removeBasketProductTiles,
    handlePrivateLogout,
    hasScrollbar,
    updateCarouselPaginationBasedOnIndex,
    appendPostalOnFocus,
    syncHeight,
    resetHeightOnTiles,
    syncHeightCarouselTiles,
    setInputFilter,
    setFilledStatus,
    handlePostalCodeInputRules,
    limitInputToRegex,
    xssEscaper,
    loadLazyImages,
    getTotalHeightToSubstract,
    getViewportHeight,
    setDynamicHeight,
    triggerClickFromParent,
    dashesToCamelCase,
    handleModalStateVisibilityQV,
    setMenuHeight,
    sanitizeValue,
    isFirefox,
    isInViewport,
    waitForEl
};
